import { useEffect } from 'react';
import { StepCommonProps } from '../types';
import { Button } from '@/isomorphic/components/typography/button/button';
import { useLogout } from '@/hooks/use-logout';

export const SubmitErrorApplication = ({ getLabel }: StepCommonProps) => {
    const { logout } = useLogout();

    useEffect(() => {
        return () => {
            logout();
        };
    }, []);

    return (
        <div className="r-relative r-mx-auto r-mb-8 r-max-w-2xl r-space-y-6 r-rounded-xl r-border-2 r-border-warning r-p-6">
            <div className="r-space-y-4 r-text-center">
                <h2 className="r-text-2xl r-font-semibold r-text-warning">{getLabel('errorTitle')}</h2>
                <p className="r-text-gray-700">{getLabel('errorDescription')}</p>
            </div>

            <div className="r-mx-auto r-flex r-max-w-xs r-flex-col r-gap-3 sm:r-flex-row sm:r-justify-center">
                <Button type="primary" fullWidth to="/">
                    {getLabel('backButton')}
                </Button>
            </div>
        </div>
    );
};
